export interface ISeasonAward {
  cash: string;
  clubId: number;
  created: string;
  eventId: number;
  eventName: string;
  note: string;
  points: number;
  roundId: number;
  roundNumber: number;
  scrip: string;
  seasonId: number;
  userFirstName: string;
  userId: number;
  userImage: string;
  userLastName: string;
  type: string;
}

export interface IMetaSeasonAward {
  position: number;
  awards: ISeasonAward[];
  total: number;
  id: number;
  height?: number;
}

export interface IAdminSeasonAwardsStore {
  [seasonId: number]: {
    [userId: number]: ISeasonAward[];
  };
}

export const adminSeasonAwardsStore: IAdminSeasonAwardsStore = {};
